import React from "react";
import { useTranslation } from "react-i18next";
import { CalcProgressCard } from "../CalcProgressCard";
import { QueuePositionDialog } from "../QueuePositionDialog";
import { BlockingMessageDialog } from "../BlockingMessageDialog";

// v0.6.8 — extracted from CalculatePanel.jsx (LOC cap): every UI
// surface driven by the async calc job's state (inline progress card,
// the queue-position popup, and the blocked/failed-outcome popup),
// grouped so CalculatePanel only needs to pass `calcPoll` through
// once instead of rendering three siblings inline.
export const CalcJobSurfaces = ({ calcPoll }) => {
  const { t } = useTranslation();
  return (
  <>
    {calcPoll.job && (
      <div className="border-t border-slate-200 dark:border-slate-700 p-4">
        <CalcProgressCard job={calcPoll.job} onCancel={calcPoll.cancel} elapsedMs={calcPoll.elapsedMs} />
        <QueuePositionDialog job={calcPoll.job} onCancel={calcPoll.cancel} />
      </div>
    )}
    <BlockingMessageDialog
      open={!!calcPoll.blockingMessage} testid="calc-blocking-message"
      severity={calcPoll.blockingMessage?.severity} title={calcPoll.blockingMessage?.title}
      onOpenChange={(o) => !o && calcPoll.dismissBlockingMessage()}
    ><p>{calcPoll.blockingMessage?.body}</p></BlockingMessageDialog>
    {/* v0.6.10 — re-running replaces the current calc, so this asks
        first. See useAsyncCalc's guardedStart (A2-646). */}
    <BlockingMessageDialog
      open={!!calcPoll.pendingRerun} testid="calc-rerun-loses-review"
      severity="warning"
      title={t("ui.calculate.rerun_dialog.title", { defaultValue: "This creates a new calculation" })}
      onOpenChange={(o) => !o && calcPoll.pendingRerun?.onCancel?.()}
      actions={[
        {
          label: t("ui.calculate.rerun_dialog.keep", { defaultValue: "Keep the current calculation" }),
          testid: "calc-rerun-cancel",
          onClick: () => calcPoll.pendingRerun?.onCancel?.(),
        },
        {
          label: t("ui.calculate.rerun_dialog.proceed", { defaultValue: "Re-run anyway" }),
          variant: "primary",
          testid: "calc-rerun-confirm",
          onClick: () => calcPoll.pendingRerun?.onProceed?.(),
        },
      ]}
    >
      <p>
        {t("ui.calculate.rerun_dialog.body_before", { defaultValue: "You have reviewed" })}{" "}
        <strong>{calcPoll.pendingRerun?.ackedCount}</strong>{" "}
        {calcPoll.pendingRerun?.ackedCount === 1
          ? t("ui.calculate.rerun_dialog.body_after_one", {
            defaultValue: "row. Most rows still flagged keep that answer in the new calculation. Figures typed into a return do not carry over.",
          })
          : t("ui.calculate.rerun_dialog.body_after_other", {
            defaultValue: "rows. Most rows still flagged keep that answer in the new calculation. Figures typed into a return do not carry over.",
          })}
      </p>
      <p className="mt-2">
        {t("ui.calculate.rerun_dialog.not_deleted", {
          defaultValue: "They are not deleted. If you re-run and change your mind, the current calculation still has them.",
        })}
      </p>
    </BlockingMessageDialog>
  </>
  );
};

export default CalcJobSurfaces;
